import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { Button } from '@xing-com/button';
import { zIndexBanner } from '@xing-com/layout-tokens';
import { ListItem } from '@xing-com/list';
import { ModalPage as DefaultModalPage } from '@xing-com/modal-page';
import {
  scale030,
  spaceL,
  spaceS,
  spaceXS,
  spaceXL,
  space4XL,
  space6XL,
} from '@xing-com/tokens';

export const ModalPage = styled(DefaultModalPage)`
  height: 100vh;
  overflow-y: auto;
`;

export const Content = styled.div`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${space4XL} ${spaceL} ${space6XL};
  width: 100%;
`;

export const ProductHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${spaceXL};
  padding-bottom: ${spaceXL};
  width: 100%;
`;

export const ProductSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${scale030};
`;

export const Pricing = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
`;

export const ActionGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
  width: 100%;
`;

export const ActionBanner = styled(ContentBanner)`
  && {
    z-index: ${zIndexBanner};
  }
`;

export const ActivationButton = styled(Button)`
  width: 100%;
`;

export const Cancellation = styled.div`
  text-align: center;
  width: 100%;
`;

export const Groups = styled.div`
  width: 100%;
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  padding: ${spaceL} 0;
`;

export const Perk = styled(ListItem)`
  align-items: flex-start;
  gap: ${spaceS};
  padding: 0;

  & + & {
    margin-top: ${spaceL};
  }

  & > svg {
    flex-shrink: 0;
  }
`;

export const PerkText = styled.span`
  flex: 0 1 auto;
  min-width: 0;
`;
